'use strict';

var FaresOptimizerDashboardDirective = function FaresOptimizerDashboardDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/fares-optimizer-dashboard.html'),
    scope: true
  };
};
FaresOptimizerDashboardDirective.$inject = [];
module.exports = FaresOptimizerDashboardDirective;